import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(() =>
  css({
    px: 'zero',
    pb: 'default',
  }),
);

themeStyles.addBaseStyles('CloseButton')(() =>
  css({
    display: 'flex',
    justifyContent: 'flex-end',
    zIndex: '10',
    position: 'relative',
    marginTop: '10px',
  }),
);

themeStyles.addBaseStyles('CloseIconWrapper')(() =>
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: 'white',
    borderRadius: '50%',
    width: '24px',
    aspectRatio: '1',
    cursor: 'pointer',
  }),
);
themeStyles.addBaseStyles('ImageContainer')(() =>
  css({
    height: ['189px', '189px', '297px'],
    width: '100%',
    mb: 'default',
  }),
);

themeStyles.addBaseStyles('CarouselImage')(() =>
  css({
    width: '100%',
    mb: 'default',
  }),
);

themeStyles.addBaseStyles('CarouselWrapper')(() =>
  css({
    mb: '44px',
    mx: ['-28px', '-28px', '-24px'],
    mt: '-45px',
  }),
);

themeStyles.addBaseStyles('Title')(() =>
  css({
    mb: ['xxs', 'xxs', '6px'],
  }),
);

themeStyles.addBaseStyles('PriceWrapper')(() =>
  css({
    mb: ['m', 'm', 'default'],
  }),
);

themeStyles.addBaseStyles('PriceSection')(({ isError }) =>
  css({
    display: 'flex',
    gap: isError ? '0' : '20px',
    justifyContent: isError ? 'center' : 'flex-start',
    backgroundColor: 'white',
    '[data-testid="loading"]': {
      margin: 0,
    },
  }),
);

themeStyles.addBaseStyles('Price')(
  css({
    display: 'flex',
    alignItems: 'center',
  }),
);

themeStyles.addBaseStyles('Finance')(
  css({
    display: 'flex',
    alignItems: 'center',
  }),
);

themeStyles.addBaseStyles('Description')(() =>
  css({
    mt: ['m', 'm', 'default'],
    fontSize: ['14px', '14px', '16px'],
    letterSpacing: '0.5px',
    lineHeight: ['22px', '22px', '26px'],
  }),
);

themeStyles.addBaseStyles('PriceContainer')(
  css({
    display: 'flex',
    flexDirection: 'row',
    pt: 'xxs',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    gap: 'xs',
  }),
);

export default themeStyles;
